export const brush = () => (
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M12 10.5L19.4706 3.02941C20.0391 2.4609 20.9609 2.4609 21.5294 3.02941C22.0744 3.57445 22.1001 4.44986 21.5881 5.02596L14.5 13M4 21H9.5C12.5376 21 15 18.5376 15 15.5C15 12.4625 12.5376 10 9.5 10H7.46154C5.54978 10 4 11.5498 4 13.4616C4 14.43 4.45598 15.342 5.23077 15.9231L6.4 16.8C7.2 17.4 7.2 18.6 6.4 19.2L4 21Z"
  />
);
